import React from 'react';

type ManagedAssetsReportProps = {
  ProfitAndLossInformation: React.FC<Record<string, unknown>>;
  ComparisonBetweenIndexAndAsset: React.FC<Record<string, unknown>>;
  isContentsEmpty: boolean;
};

const Title: React.FC<Record<string, unknown>> = () => (
  <div className="h-22.5 flex items-end p-4 text-lg font-bold text-bluegray-700 leading-tight">
    <img
      src="/static/images/report/icon-asset.svg"
      alt=""
      className="w-4 h-4 mr-2"
    />
    あなたの資産運用レポート
  </div>
);

export const ManagedAssetsReport: React.FC<ManagedAssetsReportProps> = ({
  ComparisonBetweenIndexAndAsset,
  ProfitAndLossInformation,
  isContentsEmpty,
}) => {
  if (isContentsEmpty) return null;

  return (
    <>
      <Title />
      <div className="bg-white">
        <ComparisonBetweenIndexAndAsset />
        <div className="section-block-divider"></div>
        <ProfitAndLossInformation />
      </div>
    </>
  );
};
